<template>
  <v-container class="division-main">
    <!-- bar -->
    <v-toolbar :style="{ backgroundColor: color }">
      <v-toolbar-items>
        <v-btn v-for="app in applications" :key="app.NameApp" text @click="navigateTo(app)">
          <div class="btn-div" :class="[selectedAppId == app.Id ? 'selected' : 'not-selected']">
            {{ app.NameApp }}
          </div>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <div class="iframe-div">
      <iframe id="myiframe" :src="appUrl" frameborder="0" @load="iframeLoaded()">
      </iframe>
    </div>
  </v-container>
</template>
<style>
.division,
.communication {
  height: 245px;
  position: relative;
  border-radius: 40px;
  box-shadow: 11px 13px 14px #6f767ab3;
  background-color: #ffffff;
  cursor: pointer;
}

.division-main .v-toolbar__content {
  padding-left: 40px;
  padding-right: 40px;
}

@media (max-width: 600px) {
  .division img {
    height: 50%;
    margin-top: 20px;
  }

  .division .title-div {
    font: normal normal bold 15px/18px Lato;
    text-transform: uppercase;
  }

  .division {
    height: 122px;
    border-radius: 20px;
    border-width: 4px !important;
    text-align: center;
  }

  .division-main .v-toolbar__content {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 600px) {
  .division img {
    margin-top: 40px;
    margin-bottom: 10px;
  }

  .division {
    height: 245px;
    text-align: center;
  }

  .division .title-div {
    font: normal normal bold 18px/22px Lato;
    text-transform: uppercase;
  }
}

.division .title-div,
.division .img-div {
  text-align: center;
}
</style>
<script>
import loading from "../components/loadingComponent.vue";
import { Trans } from "@/plugins/Translation";
import GAApi from "../api/GA/GAApi.js";
import router from "@/router/index.js";

export default {
  data() {
    return {
      applications: [],
      color: "",
      appUrl: "",
      selectedAppId: null,
      selectedDivision: "",
      selectedAppName: "",
    };
  },
  async created() {
    const divisionId = this.$route.params.DivisionId;
    this.color = this.$genericClass.getColor(divisionId);
    this.selectedDivision =
      this.$genericClass.getProfileDivisions()[divisionId - 1].title;

    this.closeMenu();
    let userId = this.$GAUserAuth.user.id;
    let res = await GAApi.GetApplications(userId, divisionId);
    this.applications = res.data;
    if (this.applications.length == 0) {
      router.push({ name: "quotations", params: { DivisionId: divisionId } });
      return;
    }

  },
  mounted() {
    if (window.addEventListener)
      window.addEventListener("message", this.ReceiveMessage);
    else window.attachEvent("onmessage", this.ReceiveMessage);
  },
  destroyed() {
    if (window.addEventListener)
      window.removeEventListener("message", this.ReceiveMessage);
    else window.attachEvent("onmessage", this.ReceiveMessage);
  },
  methods: {
    iframeLoaded() {
      this.adaptToolbar();
    },
    adaptToolbar() {
      var iframe = document.getElementById("myiframe");
      var adaptiveToolbarApps =
        process.env.VUE_APP_ADAPTIVE_TOOLBAR_APPS.split(",").map(Number);

      if (adaptiveToolbarApps.includes(this.selectedAppId)) {
        iframe.style.visibility = "hidden";
        // send message to child
        iframe.contentWindow.postMessage({ changeNavbarColor: true }, "*");
      } else {
        iframe.style.visibility = "visible";
      }
    },
    ReceiveMessage(event) {
      if (event.data.navbarColorChanged) {
        var iframe = document.getElementById("myiframe");
        iframe.style.visibility = "visible";
      }
    },
    navigateTo(app) {
      let url_array = app.ApplicationUrlApp.split(".");
      url_array[url_array.length - 2] = this.$genericClass.GetCurrentDomain();
      url_array.pop();
      let newurlApp = url_array.join(".");
      this.appUrl = newurlApp;
      this.selectedAppId = app.Id;
      this.selectedAppName = app.NameApp;

      if (document.getElementById("myiframe") !== null) this.adaptToolbar();
    },
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };
      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },
};
</script>